import './Menu.css';
import { LinkWithQuery } from './LinkWithQuery';
import { ReactComponent as LimeIcon } from '../icons/logo_lime.svg';
import { LimelIcon } from "../limel";

function Menu() {

    return (
        <div className="menu">
            <div className="menu-item">
                <LinkWithQuery to="/">
                    <LimeIcon />
                </LinkWithQuery>
            </div>
            <div className="menu-item nav" >
                <LinkWithQuery to="/">
                    <LimelIcon name="maintenance" ></LimelIcon>
                </LinkWithQuery>
            </div>
            <div className="menu-item nav" >
                <LinkWithQuery to='/wiki'>
                    <LimelIcon name="document" ></LimelIcon>
                </LinkWithQuery>
            </div>
        </div>
    );
}
export { Menu };
